module.exports = __webpack_public_path__ + "img/low-furniture.7f50120.svg";